import { Link } from 'react-router-dom';
import { BreadcrumbData } from 'use-react-router-breadcrumbs';

type Props = {
    breadcrumbs: BreadcrumbData[];
    maxElements?: number;
};

export const Breadcrumbs = ({ breadcrumbs, maxElements }: Props) => {
    const elements = !maxElements ? breadcrumbs : breadcrumbs.slice((maxElements + 1) * -1);

    return (
        <ul className="breadcrumbs mb-xl border-border-default pb-base pl-2xl -mt-4 -ml-2 border-b sm:-ml-6">
            {elements.map((item, index, array) => (
                <li key={item.key}>
                    {index !== array.length - 1 ? (
                        <Link key={item.key} state={index <= 0 ? { preventRedirect: true } : undefined} to={item.key}>
                            {item.breadcrumb}
                        </Link>
                    ) : (
                        <span key={item.key}>{item.breadcrumb}</span>
                    )}
                </li>
            ))}
        </ul>
    );
};
